module.exports = __webpack_public_path__ + "img/dots_mtb3.ee2ce450.png";